var _circle, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLsLocked(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Level_Status_Icon",
    "data-name": "Level Status Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#e1e7e9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(2 2)",
    fill: "#8c8c8c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2903",
    "data-name": "Group 2903",
    transform: "translate(-305.582 -964.513)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    d: "M3.1,1.24A1.729,1.729,0,0,0,1.24,2.791,1.729,1.729,0,0,0,3.1,4.342,1.729,1.729,0,0,0,4.962,2.791,1.729,1.729,0,0,0,3.1,1.24M3.1,0A2.958,2.958,0,0,1,6.2,2.791,2.958,2.958,0,0,1,3.1,5.582,2.958,2.958,0,0,1,0,2.791,2.958,2.958,0,0,1,3.1,0Z",
    transform: "translate(316.481 972)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 11.164,
    height: 9.924,
    rx: 4,
    transform: "translate(314 975.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_96_-_Outline",
    "data-name": "Rectangle 96 - Outline",
    d: "M2.481.62A1.863,1.863,0,0,0,.62,2.481V7.443A1.863,1.863,0,0,0,2.481,9.3h6.2a1.863,1.863,0,0,0,1.861-1.861V2.481A1.863,1.863,0,0,0,8.683.62h-6.2m0-.62h6.2a2.481,2.481,0,0,1,2.481,2.481V7.443A2.481,2.481,0,0,1,8.683,9.924h-6.2A2.481,2.481,0,0,1,0,7.443V2.481A2.481,2.481,0,0,1,2.481,0Z",
    transform: "translate(314 975.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M0,5.584.994,3.067A1.712,1.712,0,0,1,.364,1.746,1.777,1.777,0,0,1,2.173,0,1.779,1.779,0,0,1,3.982,1.746a1.713,1.713,0,0,1-.631,1.322l.991,2.516Z",
    transform: "translate(317.411 977.272)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2_-_Outline",
    "data-name": "Union 2 - Outline",
    d: "M-10132.57-20138.035l-.823-2.086.347-.287a1.1,1.1,0,0,0,.406-.846,1.159,1.159,0,0,0-1.189-1.125,1.16,1.16,0,0,0-1.188,1.125,1.093,1.093,0,0,0,.405.844l.346.289-.824,2.086h2.521m.91.619H-10136l.993-2.518a1.712,1.712,0,0,1-.629-1.32,1.777,1.777,0,0,1,1.809-1.746,1.779,1.779,0,0,1,1.81,1.746,1.712,1.712,0,0,1-.631,1.322Z",
    transform: "translate(10453.413 21120.271)",
    fill: "#8c8c8c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLsLocked);
export default __webpack_public_path__ + "static/media/icon_ls_locked.5f388c34f129c8f5547ca80ca400ef27.svg";
export { ForwardRef as ReactComponent };